import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

const payerIndexRoute: RouteObject = {
  index: true,
  lazy: () =>
    import('./management/PayerManagementRoute').then((m) => ({
      Component: m.PayerManagementRoute,
    })),
};

const payerNotFoundRoute: RouteObject = {
  path: '*',
  element: (
    <NotFoundChildRoute routePath="/payers" linkText="Go back to payers" />
  ),
};

export const payerRoutes: RouteObject[] = [
  payerIndexRoute,
  {
    path: 'pricing',
    lazy: () =>
      import('src/features/pricing/management/PricingManagementRoute').then(
        (m) => ({ Component: m.PricingManagementRoute })
      ),
  },
  payerNotFoundRoute,
];

// Restricted support reaches Payers and nothing else. Hiding the tab is not
// enough on its own, because the pricing scheme API permits the role.
export const restrictedSupportPayerRoutes: RouteObject[] = [
  payerIndexRoute,
  payerNotFoundRoute,
];
